var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-container c-cases"},[_c('TitleBarOnlyText',{attrs:{"msg":_vm.msg}}),(_vm.$store.state.currentLanguage.id==0)?_c('CCaseZh'):_c('CCaseEn')],1)}
var staticRenderFns = []

export { render, staticRenderFns }